import { render, staticRenderFns } from "./SupplierPrestationEdit.vue?vue&type=template&id=159edb06&scoped=true"
import script from "./SupplierPrestationEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierPrestationEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159edb06",
  null
  
)

export default component.exports